// extracted by mini-css-extract-plugin
export var statItem = "_jw-1";
export var statsRow = "_jw-0";